import { makeStyles } from '@material-ui/core';

export const useSignInStyles = makeStyles((theme) => ({
  title: (prop) => ({
    fontFamily: 'MuseoSans',
    fontSize: '50px',
    fontWeight: '300',
    lineHeight: '0.8',
    color: '#fff',
    // width: '220px',
    textAlign: 'center',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    userSelect: 'none',
  }),
  subtitle: (prop) => ({
    fontFamily: 'MuseoSans',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '1.13',
    color: '#fff',
    // width: '220px',
    textAlign: 'center',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    userSelect: 'none',
  }),
  titleForSignUp: () => ({
    fontFamily: 'MuseoSans',
    fontSize: '16px',
    lineHeight: '1.25',
    fontWeight: '700',
    color: '#fff',
    textAlign: 'center',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    userSelect: 'none',
  }),
  subtitleForSignUp: () => ({
    fontFamily: 'MuseoSans',
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '1.13',
    color: '#fff',
    textAlign: 'center',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    userSelect: 'none',
  }),
  otherText: () => ({
    fontFamily: 'MuseoSans',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '24px',
    color: '#fff',
    textAlign: 'center',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    userSelect: 'none',
  }),
  emailContainer: {
    display: 'flex',
    height: '48px',
    userSelect: 'none',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '2px solid white',
        borderColor: (err) => (err?.wrongEmailFormat ? 'red' : 'white'),
      },
      '&:hover fieldset': {
        border: '2px solid white',
        borderColor: (err) => (err?.wrongEmailFormat ? 'red' : 'white'),
      },
      '&:not(:hover) fieldset': {
        border: '2px solid white',
        borderColor: (err) => (err?.wrongEmailFormat ? 'red' : 'white'),
      },
    },
  },
  passwordContainer: {
    display: 'flex',
    height: '48px',
    userSelect: 'none',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '2px solid white',
        borderColor: (err) => (err?.wrongEmailFormat ? 'red' : 'white'),
      },
      '&:hover fieldset': {
        border: '2px solid white',
        borderColor: (err) => (err?.wrongEmailFormat ? 'red' : 'white'),
      },
      '&:not(:hover) fieldset': {
        border: '2px solid white',
        borderColor: (err) => (err?.wrongEmailFormat ? 'red' : 'white'),
      },
    },
  },
  confirmButton: {
    height: '54.7px',
    width: '100%',
    marginTop: '26.6px',
    marginBottom: ' 18px',
    backgroundColor: '#97d3c5',
    '&:disabled': {
      color: 'white',
    },
    '&:active': {
      color: 'white',
      backgroundColor: '#97d3c5',
    },
    '&:click': {
      color: 'white',
      backgroundColor: '#97d3c5',
    },
    '&:focus': {
      color: 'white',
      backgroundColor: '#97d3c5',
    },
    '&:hover': {
      color: 'white',
      backgroundColor: '#97d3c5',
    },
  },
  buttonText: {
    fontSize: '20px',
    lineHeight: '24px',
    fontFamily: 'MuseoSans',
  },
  statement: {
    marginTop: '17.5px',
    paddingBottom: '20px',
    fontFamily: 'MuseoSans',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '-0.17px',
    textAlign: 'center',
    color: '#fff',
    textTransform: 'uppercase',
    userSelect: 'none',
  },
}));

export const inputProps = {
  fontFamily: 'MuseoSans',
  fontSize: '16px',
  lineHeight: '24px',
  color: '#ffffff',
  textAlign: 'center',
  userSelect: 'none',
};
